import { render, staticRenderFns } from "./HomeWhole.vue?vue&type=template&id=4fdd2c7e"
import script from "./HomeWhole.vue?vue&type=script&lang=js"
export * from "./HomeWhole.vue?vue&type=script&lang=js"
import style0 from "./HomeWhole.vue?vue&type=style&index=0&id=4fdd2c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports